export const formatDate = (dateString) => {
  if (!dateString) return "";

  const cleaned = dateString.replace("Z", "").split(".")[0];
  const [date] = cleaned.split("T");
  if (!date) return "";

  const [year, month, day] = date.split("-");
  return `${day}/${month}/${year}`;
};

export const formatTime = (dateString) => {
  if (!dateString) return "N/A";

  const cleaned = dateString.replace("Z", "").split(".")[0];
  const [, time] = cleaned.split("T");
  if (!time) return "N/A";

  const [hour, minute] = time.split(":");
  return `${hour}:${minute}`;
};

export const formatDateTime = (dateString) => {
  if (!dateString) return "";
  const date = formatDate(dateString);
  const time = formatTime(dateString);
  return date && time ? `${date}, ${time}` : date || time || "";
};